var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 90,
    viewBox: "0 0 95 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6142 9.6709L76.6895 63.4977L45.6142 117.327L25.8366 105.903L43.725 74.9145H7.9375V52.081H43.7277L25.8392 21.0824L45.6142 9.6709Z",
    stroke: "url(#paint0_linear_185_37)",
    strokeWidth: 2.64583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3965 9.6709L63.5027 40.6589L76.6869 63.5004L63.5027 86.3339L81.3965 117.333L101.174 105.908L83.2776 74.9198H119.063V52.0863H83.2776L101.177 21.085L81.3965 9.6709Z",
    stroke: "url(#paint1_radial_185_37)",
    strokeWidth: 2.64583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_37",
    x1: 49.5,
    y1: 18.5,
    x2: 42,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1B1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_185_37",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82 10) rotate(89.1737) scale(104.011 53.6758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825987,
    stopColor: "#7E1B1F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage2);
export default __webpack_public_path__ + "static/media/card-image2.d294ef622e4d56296c4886783f0995f1.svg";
export { ForwardRef as ReactComponent };